import React from "react";

export const Ruler = (): JSX.Element => {
  return (
    <svg
      fill="#000000"
      width="20px"
      height="20px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1493.492.024.941 1492.583l426.444 426.438 180.887-180.886.12.12 75.385-75.381-.12-.12 75.387-75.39.118.12 75.385-75.382-.118-.12 75.385-75.39.12.12 75.384-75.381-.118-.12 75.388-75.38.12.11 75.38-75.381-.12-.12 75.391-75.381.12.11 75.38-75.381-.12-.12 75.392-75.385.12.12 75.38-75.386-.12-.12 75.391-75.384.11.118 75.39-75.385-.12-.119 75.392-75.386.11.12 75.39-75.386-.12-.118 180.886-180.888L1493.492.024Zm170.182 531.947 105.495-105.502-275.677-275.674-1341.78 1341.788 275.673 275.676 105.502-105.505-100.144-100.148 75.385-75.38 100.144 100.137 75.386-75.38-100.144-100.148 75.385-75.381 100.145 100.138 75.384-75.381-175.53-175.529 75.387-75.39 175.53 175.528 75.385-75.38-100.144-100.148 75.385-75.381 100.147 100.148 75.38-75.39-100.138-100.144 75.381-75.385 100.148 100.143 75.38-75.385-175.528-175.53 75.391-75.385 175.529 175.53 75.38-75.386-100.148-100.144 75.391-75.385 100.148 100.143 75.38-75.385-100.147-100.144 75.39-75.386 100.149 100.145Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
